import PencilSlash from './PencilSlash';

export default PencilSlash;
